import {cDisplay} from '../creator/cDisplay'
import { cGame } from '../creator/cGame';
import {cScene} from '../creator/cScene'


export class result2Display extends cDisplay {

  init(){
    super.init()
    console.log('INIT Result');
    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{

      switch (b.command){
        case 'update_scoring':
          var curScoreing = cGame.current.state.get('2::scoring',{})
          if (!curScoreing[ b.payload.type ] || curScoreing[ b.payload.type ] < b.payload.score){
            curScoreing[ b.payload.type ] = b.payload.score
          }
          cGame.current.state.set('2::scoring',curScoreing)
          break;
      }

    })
  }

  buildScene(){    
    super.buildScene();
  }

}
